import axios from 'axios';

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.taudigitaltutor.com'
    : 'http://localhost:5000');

export const apiBaseURL = baseURL;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  res => res,
  err => {
    // Session expired or invalidated — force re-login
    const is401 = err.response && err.response.status === 401;
    if (is401 && window.location.pathname !== '/login') {
      localStorage.removeItem('userProfile');
      window.location.assign('/login');
      return Promise.reject(err);
    }

    const isTimeout   = err.code === 'ECONNABORTED';
    const isNetwork   = !err.response;
    const is5xx       = err.response && err.response.status >= 500;
    const shouldRedirect =
      window.location.pathname !== '/unavailable' &&
      (isTimeout || isNetwork || is5xx);

    if (shouldRedirect) {
      window.location.assign('/unavailable');
    }
    return Promise.reject(err);
  },
);
export default axiosInstance;
